import {
  SET_ELASTIC_SEARCH_DEGREE_DATA,
  SET_JD_ROLE_DATA,
  SET_NEW_COMPANY_LIST,
  SET_ROLE_DATA,
  SET_SPECIALISATION_LIST,
} from './actions'
const INITIAL_STATE = {
  countryList: [],
  companyList: [],
  perfCityList: [],
  roleData: {},
  jdDetails: {},
  elasticSearchDegreeData: [],
  specialisationList: [],
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_COUNTRIES':
      return {
        ...state,
        countryList: action?.data,
      }
    case 'SET_LIST_OF_PERF_CITY':
      return {
        ...state,
        perfCityList: action.data,
      }
    case SET_SPECIALISATION_LIST:
      return {
        ...state,
        specialisationList: action.data,
      }
    case SET_NEW_COMPANY_LIST:
      return {
        ...state,
        companyList: action?.data,
      }
    case SET_ROLE_DATA:
      return {
        ...state,
        roleData: action?.data,
      }
    case SET_JD_ROLE_DATA:
      return {
        ...state,
        jdDetails: action?.data,
      }

    case SET_ELASTIC_SEARCH_DEGREE_DATA:
      return {
        ...state,
        elasticSearchDegreeData: action.data,
      }
    default:
      return state
  }
}
